<template>
  <div class="quickSupportCommandsList">
    <LoadingPlaceholder v-if="loading" />
    <template v-else>
      <Grid
        :ref="kgm_ref"
        :style="{height: 'auto'}"
        :data-items="kgm_computedGridItems(quickSupportCommands)"
        :columns="kgm_responsiveColumns()"
        :filterable="true"
        :filter="kgm_filter"
        :pageable="kgm_pagable"
        :page-size="kgm_take"
        :skip="kgm_skip"
        :take="kgm_take"
        :total="kgm_allGridItems(quickSupportCommands)"
        :sortable="{
          allowUnsort: kgm_allowUnsort,
          mode: kgm_sortMode
        }"
        :sort="kgm_sort"
        selected-field="selected"
        @rowclick="kgm_gridOnRowClick"
        @filterchange="kgm_gridFilterChange"
        @pagechange="kgm_gridPageChange"
        @sortchange="kgm_gridSortChange"
      >
        <div
          slot="textFilter"
          slot-scope="{props, methods}"
          class="input-group"
        >
          <input
            ref="textFilterInput"
            :value="props.value"
            type="text"
            class="form-control mr-2 rounded-right"
            placeholder="please enter a value"
            @input="(event) => {methods.change({operator: 'contains', field: props.field, value: event.target.value, syntheticEvent: event});}"
          >
          <div
            v-if="props.value"
            class="input-group-append"
          >
            <button
              class="btn btn-light border rounded"
              @click="kgm_resetInput('textFilterInput', (event) => {methods.change({operator: '', field: '', value: '', syntheticEvent: event});})"
            >
              <font-awesome-icon
                class="gray"
                icon="times"
              />
            </button>
          </div>
        </div>
        <template
          slot="optionsTemplate"
          slot-scope="{props}"
        >
          <td :class="props.className">
            <div class="btn-group">
              <button
                class="btn btn-primary btn-sm"
                @click="showSidebarEdit(props.dataItem)"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="edit"
                />
                <span>Edit</span>
              </button>
              <button
                class="btn btn-secondary btn-sm"
                @click="openConfirmModal(props.dataItem)"
              >
                <font-awesome-icon
                  class="mr-2 gray"
                  icon="trash"
                />
                <span>Remove</span>
              </button>
            </div>
          </td>
        </template>
      </Grid>
      <Sidebar
        v-if="showSidebar"
        :show-sidebar="showSidebar"
        @close="close"
      >
        <QuickSupportCommandAdd
          v-if="addingElement"
          @reload="reloadQuickSupportCommands"
        />
        <QuickSupportCommandEdit
          v-else
          :quick-support-command="quickSupportCommand"
          @reload="reloadQuickSupportCommands"
        />
      </Sidebar>
    </template>

    <SweetModal
      ref="confirmDelete"
      :title="$t('introOutroListComp.deleteElement')"
      icon="warning"
      blocking
      class="overflowHidden"
    >
      <p v-if="quickSupportCommand">
        {{ $t('sureToDelete', {'0' : quickSupportCommand.name}) }}
      </p>
      <button
        slot="button"
        class="btn btn-secondary float-left mb-3"
        @click="$refs.confirmDelete.close()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="times"
        />{{ $t('cancel') }}
      </button>
      <button
        slot="button"
        class="btn btn-danger float-right mb-3"
        @click="removeQuickSupportCommand()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="trash"
        />{{ $t('delete') }}
      </button>
      <div class="clearfix" />
    </SweetModal>
  </div>
</template>

<script>

import { SweetModal } from 'sweet-modal-vue';
import { kendoGridMixin } from '@/mixins/kendoGridMixin.js';
import Sidebar from '@/components/Base/Sidebar.vue';
import QuickSupportCommandAdd from '@/components/Device/QuickSupportCommandAdd';
import QuickSupportCommandEdit from '@/components/Device/QuickSupportCommandEdit';

export default {
  name: "QuickSupportCommandsList",
  components: {
    SweetModal,
    Sidebar,
    QuickSupportCommandAdd,
    QuickSupportCommandEdit
  },
  mixins: [
    kendoGridMixin
  ],
  data () {
    return {
      loading: true,
      quickSupportCommand: null,
      quickSupportCommands: null,
      showSidebar: false,
      addingElement: false,
      currentId: null,
      deleteIndex: null,
      kgm_columns: [
        {
          field: 'name',
          filterable: true,
          filter: 'text',
          title: 'Name',
          filterCell: 'textFilter'
        },
        {
          field: 'applicationType',
          filterable: true,
          filter: 'text',
          title: this.$t('applicationType'),
          filterCell: 'textFilter'
        },
        {
          field: 'ignoreApplicationType',
          filterable: true,
          filter: 'text',
          title: 'Ignored Application Types',
          filterCell: 'textFilter'
        },
        {
          field: 'remoteCommand',
          filterable: true,
          filter: 'text',
          title: 'Remote Command',
          filterCell: 'textFilter'
        },
        {
          filterable: false,
          title: 'Options',
          cell: 'optionsTemplate',
        }
      ]
    }
  },
  metaInfo () {
    return {
      title: this.$t('menu.quickSupportCommands')
    }
  },
  created () {
    this.getQuickSupportCommands();
  },
  methods: {
    //sidebar
    show () {
      this.showSidebar = true;
    },
    close () {
      this.showSidebar = false;
    },
    showSidebarAdd () {
      this.addingElement = true;
      this.show();
    },
    showSidebarEdit (emitValues) {
      this.setCurrentQuickSupportCommand(emitValues);
      this.addingElement = false;
      this.show();
    },
    setCurrentQuickSupportCommand (command) {
      this.quickSupportCommand = Object.assign({}, command); 
    },
    //end sidebar

    //api
    reloadQuickSupportCommands () {
      this.showSidebar = false;
      this.$emit("reloadAuditLogs");
      this.getQuickSupportCommands();
    },
    openConfirmModal (data) {
      this.setCurrentQuickSupportCommand(data);
      this.deleteIndex = data.id;
      this.$refs.confirmDelete.open();
    },
    removeQuickSupportCommand () {
      this.loading = true;
      this.axios.delete(`/CentralDeviceManagement/QuickSupportCommand?commandId=${ this.deleteIndex }`)
      .then(() => {
        this.$snotify.success(this.$t('quickSupportCommand.deletedSuccessfully'));
        this.$emit("reloadAuditLogs");
        this.getQuickSupportCommands();
      })
      .finally(() => {
        this.deleteIndex = null;
        this.$refs.confirmDelete.close();
      });
    },
    getQuickSupportCommands () {
      this.showSidebar = false;
      this.loading = true;
      this.axios.get('/CentralDeviceManagement/QuickSupportCommand')
      .then((response) => {
        if (response == null) {
          return;
        }
        if (response.data == null) {
          return;
        }
        this.quickSupportCommands = response.data;
      })
      .finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
<style>
.quickSupportCommandsList .k-grid table tr:hover td {
  background :rgb(219, 219, 219) !important;
  cursor: pointer !important;
}
</style>